import React from "react";

import clsx from "clsx";

import { LoadingSlideNoText } from "@components/title-slide-view";

import { ChangeFractionDisplay } from "./change-fraction-display";

interface Props {
  value: string;
  fractionChangeValue: number;
  isPositiveChangeGood: boolean;
  className?: string;
  compareDataLoading?: boolean;
  showChangeFraction: boolean;
}

export const MetricsSection = ({
  value,
  fractionChangeValue,
  isPositiveChangeGood,
  compareDataLoading,
  showChangeFraction,
  className,
}: Props) => (
  <div
    className={clsx(
      "font-mono metric-content truncate flex flex-col",
      className,
    )}
  >
    <div className="text-right truncate">{value}</div>
    {showChangeFraction && (
      <div className="text-xs text-right relative truncate">
        {compareDataLoading ? (
          <LoadingSlideNoText className="w-6 z-[0]" />
        ) : (
          <ChangeFractionDisplay
            value={fractionChangeValue}
            isPositiveChangeGood={isPositiveChangeGood}
          />
        )}
      </div>
    )}
  </div>
);
